import React from 'react';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { Countdown } from './components/Countdown';
import { Pricing } from './components/Pricing';
import { Steps } from './components/Steps';
import { FAQ } from './components/FAQ';
import { ValueStack } from './components/ValueStack';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { OfferBanner } from './components/OfferBanner';
export function App() {
  return <div className="min-h-full w-full overflow-x-hidden text-plum" data-id="element-0" data-mp="2wj8dbo48im46">
      <MetaPixel data-id="element-1" data-mp="28tw5arkn8k3g" />
      <OfferBanner data-id="element-2" data-mp="28te1n9vnj3li" />
      <main data-id="element-3" data-mp="28suvsrja05nu">
        <Hero data-id="element-4" data-mp="28sbbj465l56n" />
        <Stats data-id="element-5" data-mp="28s2z1ddy01vz" />
        <Testimonials data-id="element-6" data-mp="23vkuoemiy5k6" />
        <PainPoints data-id="element-7" data-mp="23u9t8lgjx9w8" />
        <Volumes data-id="element-8" data-mp="23utby4e102bb" />
        <Bonuses data-id="element-9" data-mp="23t8iki3g6pf1" />
        <Pricing data-id="element-10" data-mp="3ijxqiu0iq6lh" />
        <Steps data-id="element-11" data-mp="3ikh829m9asyz" />
        <FAQ data-id="element-12" data-mp="3iiwdwl3utc1n" />
        <Countdown spotsTaken={93} data-id="element-13" data-mp="3ij65gd4jrr9g" />
        <ValueStack data-id="element-14" data-mp="3ii4r9zs8ioni" />
      </main>
      <Footer data-id="element-15" data-mp="3mkrd9k285fcs" />
    </div>;
}